<section
  class="carousel-wrapper"
  [ngClass]="{
    'carousel-wrapper--short': !showTitles,
    'carousel-wrapper--no-footer': !isFooterShown
  }"
  #carouselWrapper
>
  <div
    class="carousel-inner"
    #carousel
    [ngStyle]="{ left: carrouselOffset + 'px' }"
  >
    <div
      *ngFor="let item of slides; let i = index"
      class="carousel-item"
      (click)="moveToSlide(i)"
    >
      <div
        *ngIf="item.fileType === PostFileMediaType.Image"
        class="carousel-item-image"
        [style.background-image]="getSanitizedUrl(item.url)"
      ></div>
      <div
        *ngIf="item.fileType === PostFileMediaType.Video"
        class="carousel-item-video"
      >
        <video src="{{ item.videoUrl }}" controls></video>
      </div>
      <div class="carousel-item__footer" *ngIf="isFooterShown">
        <div class="carousel-item__form">
          <ng-container *ngIf="showTitles">
            <h3 class="carousel-item__title">
              {{
                "brand.campaign.contentCalendarCarouselPost.carouselItem.headingLabel"
                  | translate
              }}
            </h3>
            <mat-form-field class="carousel-item__input">
              <mat-label>{{
                "brand.campaign.contentCalendarCarouselPost.carouselItem.headingPlaceholder"
                  | translate
              }}</mat-label>
              <input
                matInput
                [(ngModel)]="item.title"
                (focus)="moveToSlide(i)"
                type="text"
              />
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="showDescriptions">
            <h3 class="carousel-item__title">
              {{
                "brand.campaign.contentCalendarCarouselPost.carouselItem.descriptionLabel"
                  | translate
              }}
              <app-tooltip
                [text]="
                  'brand.campaign.contentCalendarCarouselPost.carouselItem.descriptionTooltip'
                    | translate
                "
              ></app-tooltip>
            </h3>
            <mat-form-field class="carousel-item__input">
              <input
                matInput
                [(ngModel)]="item.description"
                (focus)="moveToSlide(i)"
                type="text"
              />
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="showAltTexts">
            <h3 class="carousel-item__title">
              {{
                "brand.campaign.contentCalendarCarouselPost.carouselItem.altTextLabel"
                  | translate
              }}
              <app-tooltip
                [text]="
                  'brand.campaign.contentCalendarCarouselPost.carouselItem.altTextTooltip'
                    | translate
                "
              ></app-tooltip>
            </h3>
            <mat-form-field class="carousel-item__input">
              <input
                matInput
                [(ngModel)]="item.title"
                (focus)="moveToSlide(i)"
                type="text"
              />
            </mat-form-field>
          </ng-container>
        </div>
      </div>
      <span class="carousel-item-details">
        <button class="delete" (click)="onDeleteItem(item)" tabindex="-1">
          <mat-icon>delete</mat-icon>
        </button>
      </span>
    </div>
  </div>

  <div *ngIf="!!slides" class="buttons">
    <button
      (click)="prev()"
      class="button button-prev"
      *ngIf="currentSlide > 0"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button
      (click)="next()"
      class="button button-next"
      *ngIf="currentSlide < slides.length - 1"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</section>
